import styled from '@mui/material/styles/styled'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'

export const StyledMuiTooltip = styled(({ className, ...rest }) => <Tooltip {...rest} classes={{ popper: className }} />, {
  shouldForwardProp: (prop) => prop !== 'maxWidth'
})(({ theme, maxWidth = 300 }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    borderRadius: 20,
    padding: theme.spacing(2, 3),
    boxShadow: '0px 0px 13px 0px rgba(0, 21, 41, 0.20)',
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    maxWidth: maxWidth,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white
  }
}))
